<div (click)="onSortRequested()" class="custom-header">
  <span class="header-label">{{ params.displayName }}</span>
  @if (sort === '') {
    <span></span>
  }
  @if (sort === 'asc') {
    <span><app-icon-arrow-down></app-icon-arrow-down></span>
  }
  @if (sort === 'desc') {
    <span><app-icon-arrow-up></app-icon-arrow-up></span>
  }
</div>
